import ModalDrag from '@/component/ModaDrag/ModalDrag'
import { Col, Input, message, Row } from 'antd'
import React, { useEffect, useReducer, useState } from 'react'
import GlobalCss from '@/global.module.less'
import css from './public-dataset-form-modal.module.less'
import { sendHttpPostRequest } from '@/api/http-request'

function PublicDatasetFormModal(props: any) {
  const {
    mode,
    open,
    setOpen,
    actionCallback,
    actionDataset,
  } = props

  const datasetInfoReducer = (state, action) => {
    switch (action.type) {
      case 'UPDATE_PROPERTY':
        return { ...state, [action.payload.key]: action.payload.value }
      case 'UPDATE_ALL_OBJ':
        return action.payload
      // case 'UPDATE_IMAGE_INFO':
      //     return {...state,env[action.payload.index][value]: action.payload.value}
      default:
        return state
    }
  }

  const initialDatasetInfo = {
    title: '',
    description: '',
  }

  const [datasetInfo, dispatch] = useReducer(
    datasetInfoReducer,
    initialDatasetInfo
  )

  useEffect(() => {
    if (mode == 'edit') {
      dispatch({ type: 'UPDATE_ALL_OBJ', payload: actionDataset })
    } else {
      dispatch({ type: 'UPDATE_ALL_OBJ', payload: initialDatasetInfo })
    }
    return () => {
    }
  }, [open, actionDataset])

  const datasetFormContent = (
    <div className={css.formContain}>
      <Row align={'middle'} justify={'start'} className={GlobalCss.formRow}>
        <Col className={GlobalCss.requiredLabel}>名称</Col>
        <Col>
          <Input
            value={datasetInfo?.title}
            style={{
              width: '350px',
            }}
            placeholder="请输入数据集名称，不超过50字符"
            maxLength={50}
            onChange={(e) => {
              dispatch({
                type: 'UPDATE_PROPERTY',
                payload: { key: 'title', value: e.target.value },
              })
            }}
          />
        </Col>
      </Row>
      <Row align={'top'} justify={'start'} style={{marginTop:15}} className={GlobalCss.formRow}>
        <Col className={css.defaultLabel}>描述</Col>
        <Col>
          <Input.TextArea
            value={datasetInfo?.description}
            style={{
              minHeight: '145px',
              width: '350px',
            }}
            placeholder="请输入数据集描述"
            onChange={(e) => {
              dispatch({
                type: 'UPDATE_PROPERTY',
                payload: { key: 'description', value: e.target.value },
              })
            }}
          />
        </Col>
      </Row>
    </div>
  )

  const onOk = () => {
    let data = datasetInfo
    if (mode == 'create') {
      sendHttpPostRequest(
        'dataset/api/oam_create_public_dataset/',
        data,
        (res) => {
          console.log(res)
          if (res.code == 0) {
            message.success('创建成功~')
            actionCallback()
          } else {
            message.error(res.message)
          }
        }
      )
    } else {
      sendHttpPostRequest(
        'dataset/api/oam_update_public_dataset/',
        {
          dataset_id: data.id,
          description: data.description,
          title: data.title,
        },
        (res) => {
          if (res.code == 0) {
            message.success('更新成功~')
            actionCallback()
          } else {
            message.error(res.message)
          }
        }
      )
    }
    setOpen(false)
  }
  return (
    <ModalDrag
      width={480}
      modalTitle={mode == 'create' ? '创建数据集' : '编辑数据集'}
      modalContent={datasetFormContent}
      open={open}
      onOk={onOk}
      onCancel={() => setOpen(false)}
    />
  )
}

export default PublicDatasetFormModal
